// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1BYRi","fileBtn":"File_fileBtn__2zJYy","closeBtn":"File_closeBtn__D5SHm","fileSelected":"File_fileSelected__1y6le","disabled":"File_disabled__2OAkk"};